import { Button } from "components/Button";
import { DangerButton } from "components/Button/Danger";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { MdPerson } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { authAPI } from "services/auth";
import { useAppStore } from "store/appStore";
import { ConnectWalletDialog } from "./components/ConnectWalletDialog";
import { shortenAddress } from "utils/shortenAddress";
import { AdminRole } from "types/auth";
import { useAccount, useDisconnect } from "wagmi";
import { NetworkSwitcher } from "./components/components/NetworkSwitcher";
import { useNetworksStore } from "store/networksStore";
import { isSolanaNetwork } from "types/networks";
import { useSolanaWallet } from "hooks/useSolanaWallet";

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const { onOpenSidenav, brandText } = props;
  const navigate = useNavigate();
  const { address: evmAccount } = useAccount();
  const { currentNetwork } = useNetworksStore();
  const isCurrentSolanaNetwork = isSolanaNetwork(currentNetwork);
  const { address: solanaAccount, disconnectWallet: disconnectSolanaWallet } =
    useSolanaWallet();
  const account = isCurrentSolanaNetwork ? solanaAccount : evmAccount;
  const { admin } = useAppStore();
  const { disconnectAsync } = useDisconnect();

  const handleLogout = async () => {
    await authAPI.logout();
    navigate("/auth/sign-in");
  };

  const disconnectWallet = async () => {
    if (isCurrentSolanaNetwork) {
      await disconnectSolanaWallet();
      return;
    }

    await disconnectAsync();
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>

        <NetworkSwitcher />

        {admin?.role === AdminRole.SUPER_ADMIN && (
          <>
            {account ? (
              <>
                <span
                  className="rounded-full
                  bg-[#D9893A] px-5 py-2 text-base font-medium
                  text-white disabled:pointer-events-none"
                >
                  {shortenAddress(account)}
                </span>
                <div className="h-full border-r" />
                <DangerButton
                  className="!rounded-full"
                  onClick={disconnectWallet}
                >
                  Disconnect
                </DangerButton>
              </>
            ) : (
              <ConnectWalletDialog>
                <Button className="!rounded-full">Connnect wallet</Button>
              </ConnectWalletDialog>
            )}
          </>
        )}

        <Dropdown
          button={
            <button className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-600">
              <MdPerson className="h-8 w-8 text-white" />
            </button>
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat pb-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="ml-4 mt-3">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey
                  </p>{" "}
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="ml-4 flex flex-col">
                <button
                  onClick={handleLogout}
                  className="mt-3 text-left text-sm font-medium text-red-500 hover:text-red-500"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
